// Standalone: there is no backend to render `<html lang>`, so detect the
// preferred UI language from the browser before the app boots. `loadLocale`
// reads `document.documentElement.lang` and falls back (full tag → base
// language → English) when an exact locale file is missing.

function detectBrowserLocale(): string {
  const raw = navigator.languages[0] ?? navigator.language;
  const lower = raw.toLowerCase();

  // Map Chinese variants to Mastodon's locale codes.
  if (lower.startsWith('zh')) {
    if (
      lower.includes('tw') ||
      lower.includes('hant') ||
      lower.includes('hk') ||
      lower.includes('mo')
    ) {
      return 'zh-TW';
    }
    return 'zh-CN';
  }

  return raw;
}

document.documentElement.lang = detectBrowserLocale();
